




































































import { Component, Emit, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import { TipoUsuarioEnum, RequestMessage as MSG } from '@/types/_'
import moment from 'moment'

@Component
export default class ComponentModalSolicitacaoCirurgiaMotivoCancelamento extends Vue {
  tipoUsuario: string = TipoUsuarioEnum.Medico

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get showModalMotivoCancelamento() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showMotivoCancelamento
  }

  set showModalMotivoCancelamento(value: boolean) {
    this.getSolicitacaoStore.setShowModalMotivoCancelamento(value)
  }

  formatDate(value: string) {
    return moment(value).format('DD/MM/YYYY')
  }

  async closeModalMotivoCancelamento() {
    this.setLoadingRequest(true, this.getSolicitacaoStore.requestMessage.update)
    this.showModalMotivoCancelamento = false
    this.getSolicitacaoStore.clearMotivoCancelamento()
    this.clearLoadingRequest()
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }
}
